import { createState } from '../context-utils';
import { MembershipProductContextType } from './membership-product-context-type';

export const MembershipProductEditSelector = createState((state: MembershipProductContextType) => {
  return state?.editMode;
});

export const MembershipProductSelector = createState((state: MembershipProductContextType) => {
  return state?.product;
});

export const MembershipProductAdminAccessSelector = createState((state: MembershipProductContextType) => {
  return state?.isAdminAccess;
});

export const MembershipProductJoinActionSelector = createState((state: MembershipProductContextType) => {
  return state?.joinAction;
});
